import { IBooking, ITableItem } from "shared-types/index";
import DateUtilsService from 'external-services/date-utils-service';
import store from "appRoot/Store";

interface ITableLookupItem {
  startPos: number;
  bookingsPos: number;
  height: number;
  table: ITableItem;
}

export default class TimelineService {

  /**
   * Find what table the drag is from and return it.
   * This is determined by the row you drag from, not the booking.
   */
  static getFromTable(pageY: number, scrollTop: number, tableLookup: any): ITableItem {

    /**
     * NBI-9351: Hardcoding header offset is fragile because it breaks if the header or time bar is changed,
     * so we get it from the DOM instead. 
     */
    let offsetTop = 0;
    try {
      const { headerHeight, timeBarHeight } = store.getState().layoutReducer;
      offsetTop = headerHeight + timeBarHeight;
    } catch (err) {
      console.log( 'Error getting offset top', err);
    }

    if (offsetTop === 0) {
      console.error('Error getting offset top. This will break the drag booking feature on the Diary timeline! It will not be able to determine the table from the row you drag from.');
      return null;
    }

    const yPos = pageY + scrollTop - offsetTop;
    for (const propName in tableLookup) {
      const tableDetails: ITableLookupItem = tableLookup[propName];
      const pos = tableDetails.startPos;
      if (yPos > pos && yPos < (pos + tableDetails.height)) {
        return tableDetails.table;
      }
    }
    return null;
  }
  /**
   * Check if two booking are time overlap
   * @param booking
   * @param booking2
   * @returns {boolean}
   */
  static checkBookingTimeOverlap(booking: IBooking, booking2: IBooking) {
    const begin = Math.max(booking.bookingMin, booking2.bookingMin);
    const end = Math.min(booking.bookingMin + (booking.duration as number), booking2.bookingMin + (booking2.duration as number));
    return end > begin;
  }

  /**
   * Calculate the position of the booking in timeList, use array due to only few booking can be shown in one row
   * can change to tree array if one table has more booking, but not necessary
   * @param bookings
   * @param dateObj $scope.date object, the reason not use new Date() is that Date may cause
   * booking.bookingMin be decimal, which will cause the booking overlap. The original method use $scope.date object,
   * so keep it be an easier way to fix the bug
   * @returns {*[]}
   */
  static calculateSharedTableVerticalBookingPosition(bookings: IBooking[], dateObj: Date) {
    const filledArray: IBooking[][] = [];
    bookings.forEach((booking) => {
      booking.bookingMin = DateUtilsService.minsBetweenDates(dateObj, booking.time);
      const isPushed = filledArray.some((item) => {
        // check whether time overlap with other booking in the same row
        const isTimeOverlap = item.some(item2 => this.checkBookingTimeOverlap(booking, item2));
        // can put in one row
        if (!isTimeOverlap) {
          item.push(booking);
          return true;
        }
        return false;
      });
      // can not put in any row, create a new row
      if (!isPushed) {
        filledArray.push([booking]);
      }
    });
    return filledArray;
  }
}
